import React, { useState, useRef } from 'react'

// Mol
import Modal, { ModalSize } from '../../../Molecules/Modal/'
import MTooltipModal from "../../../Molecules/Modal/Part/MTooltip"

// import PlanCentralVirtual from '../../../Molecules/Cards/Plan/PlanCentralVirtual'
import General2PlanCardMol from '../../../Molecules/Cards/Plan/General2'


import {v4 as uuid} from 'uuid'
import NumberFormat from 'react-number-format';
import Parser from 'html-react-parser';

//Libraries
import Slider from "react-slick"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


function CentralVirtual (props) {
	const {
		filTipoCentral,
		filTipoPlan,
		filVelocidad,
		dataCPlanesBK,
		dataChannelsBk,
		dataCategoriasBk
	} = props

	const [impuesto, setImpuesto] = useState(1)
	const [dataCPlanes, setdataCPlanes] = useState([])
	const [idTypeCentral, setIdTypeCentral] = useState("")
	const [idTypePlan, setIdTypePlan] = useState("")
	const [idVelocidad, setIdVelocidad] = useState("")
	const [valorPrecioVelocidad, setvalorPrecioVelocidad] = useState("")
	const [textoVelocidad, settextoVelocidad] = useState("")

	const [spanSending, setSpanSending] = useState(false)

	const [showPlanes, setShowPlanes] = useState(false)

    const settingsSliderPlanes = {
		
        infinite: false,
        autoplay: false,
        speed: 800,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
		centerMode: false,
        responsive: [
            {
				breakpoint: 1102,
				settings: {
					slidesToShow: 2,
					centerMode: false
				}
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1,
					centerMode: true,
					centerPadding: '28px'
				}
			}
        ]
    }
	const modalTooltipRef = useRef()
    const openModalTooltip = () => modalTooltipRef.current.open()

	function onChangeCentralValue(e) {
		// setShowSuccessForm(false)
		setShowPlanes(false)
        let idCentral = parseInt(e.target.value)
		if(idTypeCentral !== 86) {
			if (idTypeCentral !== "" ){
				let data = {}
				getDataPlanes(data)
			}
		}
		setIdTypeCentral(idCentral)
		setIdTypePlan("")
		setIdVelocidad("")
		setvalorPrecioVelocidad(0);
		settextoVelocidad('')
        console.log("onChangeCentralValue:", idCentral)
    }

	function onChangeTypePlanValue(e) {
		// setShowSuccessForm(false)
		//setdataCPlanes([])
		setShowPlanes(false)
		let idTypePlan = parseInt(e.target.value)
		setIdTypePlan(idTypePlan)
		setIdVelocidad("")
		setvalorPrecioVelocidad(0);
		settextoVelocidad('')
        console.log("onChangeTypePlanValue:", idTypePlan)
    }
	function onChangeVelocidad(e) {
		// setShowSuccessForm(false)
		//setdataCPlanes([])	
		setShowPlanes(false)
        let idVel = parseInt(e.target.value)
		var combo = e.target;
		var precio = combo.options[combo.selectedIndex].getAttribute('precio');
		var velocidad = combo.options[combo.selectedIndex].text;
		if(precio == undefined || precio == null || precio == ''){
			setvalorPrecioVelocidad(0);
			settextoVelocidad('')
		} else {
			setvalorPrecioVelocidad(precio);
			settextoVelocidad(velocidad)
		}		
		setIdVelocidad(idVel)
        console.log("onChangeVelocidad:", idVel)
    }

	function submitData(){
		setdataCPlanes([])
		setSpanSending(true)
		setShowPlanes(true)
		console.log('idTypeCentral', idTypeCentral);

		if(idTypeCentral == 86) {
			console.log('***********************iiiii');
			setImpuesto(1.3);
			
		//if(idTypeCentral == 62) {
			if (idTypeCentral !== "" && idTypePlan !== "" && idVelocidad !== "" ){
				let data = {}
				getDataPlanes(data)
			}else{
				openModalTooltip()
				// setShowValidCobertura(true)
				setSpanSending(false)
			}
		} else {
			setImpuesto(1);
			setvalorPrecioVelocidad(0);
			//if (idTypeCentral !== "" && idTypePlan !== "" ){
			if (idTypeCentral !== "" ){
				let data = {}
				getDataPlanes(data)
			}else{
				openModalTooltip()
				// setShowValidCobertura(true)
				setSpanSending(false)
			}
		}
		
	}

	const getDataPlanes = async (data)=>{
		let newPlans = []

		if(idTypeCentral !== "" ){
			dataCPlanesBK?.map((item, index)=>{
				let flCent = []
				flCent = item?.lstFiltrosxPlan.filter(fl => fl.fi_OPCION_FILTRO === idTypeCentral)
				if( flCent.length > 0){
					newPlans.push(item)
				}
			})
		}

		if(idTypePlan !== "" ){
			let arrayToFilter = newPlans.length > 0 ? newPlans : dataCPlanesBK
			newPlans=[]
			arrayToFilter?.map((item, index)=>{
				let flCent = []
				flCent = item?.lstFiltrosxPlan.filter(fl => fl.fi_OPCION_FILTRO === idTypePlan)
				if( flCent.length > 0){
					newPlans.push(item)
				}
			})
		}
		/*
		if(idVelocidad !== "" && idTypeCentral === 86 ){
			let arrayToFilter = newPlans.length > 0 ? newPlans : newPlans
			newPlans=[]
			arrayToFilter?.map((item, index)=>{
				let flCent = []
				flCent = item?.lstFiltrosxPlan.filter(fl => fl.fi_OPCION_FILTRO === idVelocidad)
				if( flCent.length > 0){
					newPlans.push(item)
				}
			})
		} */
		console.log("getDireccion by category=", newPlans)
		setdataCPlanes(newPlans)
		setSpanSending(false)
	}

	const optionsCentral = filTipoCentral?.length ? filTipoCentral[0]?.lstOpcionFiltro.map((item, index) => (
		<option key={uuid()} value={item.fi_opcion_filtro}>{item.fc_descripcion}</option>
    )) : null

	const optionsTypePlan = filTipoPlan?.length ? filTipoPlan[0]?.lstOpcionFiltro.map((item, index) => (
		<option key={uuid()} value={item.fi_opcion_filtro}>{item.fc_descripcion}</option>
    )) : null

	const optionsVelocidad = filVelocidad?.length ? filVelocidad[0]?.lstOpcionFiltro.map((item, index) => (
		<option key={uuid()} precio={item.fi_precio} value={item.fi_opcion_filtro}>{item.fc_descripcion}</option>
    )) : null

	const PlayPLanData = dataCPlanes.length ? dataCPlanes.map((item, index) => (
        <div key={uuid()} className="c23Item" data-idplan={item.fi_PLAN}>
            <General2PlanCardMol
                key={uuid()}
                title={item.fc_TEXTO_CAJA.trimEnd()}
                titlestyle={item.fc_COLOR_CAJA ? item.fc_COLOR_CAJA.toLowerCase() : null}
                name={item.fc_NOMBRE.trimEnd()}
                fi_PLAN={item.fi_PLAN}
                fi_ID_TELEFONIA={item.fi_ID_TELEFONIA}
                fi_ID_TELEVISION={item.fi_ID_TELEVISION}
                fi_ID_INTERNET={item.fi_ID_INTERNET}
                fi_CATEGORIA={item.fi_CATEGORIA}
                fc_TIPO_DISPONIBILIDAD={item.fc_TIPO_DISPONIBILIDAD}
                fc_TEXTO_CAJA={item.fc_TEXTO_CAJA}
                fc_COLOR_CAJA={item.fc_COLOR_CAJA}
                fc_NOMBRE={item.fc_NOMBRE}
                fc_DESCRIPCION={item.fc_DESCRIPCION}
                fi_NUMERO_CARACTERISTICAS_MOSTRAR={item.fi_NUMERO_CARACTERISTICAS_MOSTRAR}
                fc_TITULO_CARACTERISTICAS_AGRUPADAS={item.fc_TITULO_CARACTERISTICAS_AGRUPADAS}
                fi_PRECIO_PLAN={item.fi_PRECIO_PLAN > 0 ? <NumberFormat thousandSeparator={","} decimalSeparator={"."} displayType={'text'} value={ Math.round(Number.isInteger(parseInt(item.fi_PRECIO_PLAN)+parseInt(valorPrecioVelocidad))*impuesto)  ? Math.round((parseFloat(item.fi_PRECIO_PLAN)+parseFloat(valorPrecioVelocidad))*impuesto) : Math.round(parseFloat(parseFloat(item.fi_PRECIO_PLAN) + parseFloat(valorPrecioVelocidad))*impuesto).toFixed(2)} />: null}
                fi_PRECIO_TELEFONIA_ENPS={item.fi_PRECIO_TELEFONIA_ENPS}
                fi_PRECIO_TELEVISION_ESPN={item.fi_PRECIO_TELEVISION_ESPN}
                fi_PRECIO_INTERNET_ESPS={item.fi_PRECIO_INTERNET_ESPS}
                fc_COLOR_PRECIO={item.fc_COLOR_PRECIO}
                fc_ETIQUETA_PRECIO_TACHADO={item.fc_ETIQUETA_PRECIO_TACHADO}
                fc_PRECIO_TACHADO={<NumberFormat thousandSeparator={","} decimalSeparator={"."} displayType={'text'} value={item.fc_PRECIO_TACHADO.includes(".") ? item.fc_PRECIO_TACHADO : item.fc_PRECIO_TACHADO } />}
                Discount={item?.fc_PRECIO_TACHADO > 0 && parseInt(item.fc_PRECIO_TACHADO) !== parseInt(item.fi_PRECIO_PLAN) ? <NumberFormat displayType={'text'} value={(100 - (item.fi_PRECIO_PLAN * 100) / item.fc_PRECIO_TACHADO).toFixed(0)} /> : null}
                fc_NOTA_DEBAJO_PRECIO={item.fc_NOTA_DEBAJO_PRECIO}
                fc_TEXTO_DETALLE={item.fc_TEXTO_DETALLE}
                fc_URL_DETALLE={item.fc_URL_DETALLE}
                fc_TARGET_DETALLE={item.fc_TARGET_DETALLE}
                fi_BAN_DETALLE={item.fi_BAN_DETALLE}
                fc_OPCION_CONTRATACION={item.fc_OPCION_CONTRATACION}
                fc_TEXTO_CONTRATAR={item.fc_TEXTO_CONTRATAR}
                fc_URL_CONTRATAR={item.fc_URL_CONTRATAR}
                fc_TARGET_CONTRATAR={item.fc_TARGET_CONTRATAR}
                fi_BAN_CONTRATAR={item.fi_BAN_CONTRATAR}
                fi_ORDEN={item.fi_ORDEN}
                fi_ACTIVO={item.fi_ACTIVO}
                fi_ID_DASHBOARD={item.fi_ID_DASHBOARD}
                fi_BAN_ENPN={item.fi_BAN_ENPN}
                fi_BAN_ENPS={item.fi_BAN_ENPS}
                fi_BAN_ESPN={item.fi_BAN_ESPN}
                fi_BAN_ESPS={item.fi_BAN_ESPS}
                fc_ETIQUETA_PROMOCION_ATP={item.fc_ETIQUETA_PROMOCION_ATP}
                fi_PRECIO_AHORRO={item.fi_PRECIO_AHORRO}
                fc_ETIQUETA_PERIODO={item.fc_ETIQUETA_PERIODO}
                fc_TITULO_PROMO={item.fc_TITULO_PROMO}
                Caracteristicas={item.caracteristicas}
                caracteristicasPromocion={item.caracteristicasPromocion}
                Acordeon={item.acordeon}
                lstPlanContratacionxPlan={item.lstPlanContratacionxPlan}
                fi_INCLUIR_SECCION={item.fi_INCLUIR_SECCION}
                fc_ETIQUETA_ROJA={item.fc_ETIQUETA_ROJA}
                fc_TITULO_SECCION={item.fc_TITULO_SECCION}
                fc_DESCRIPCION_SECCION={item.fc_DESCRIPCION_SECCION}
                fc_TEXTO_BOTON={item.fc_TEXTO_BOTON}
                fc_TARGET_BOTON={item.fc_TARGET_BOTON}
                fc_URL_BOTON={item.fc_URL_BOTON}
                fc_DESCRIPCION_OFERTA={item.fc_DESCRIPCION_OFERTA}
                fc_PLAN_ICONO={item.fc_PLAN_ICONO}
                fi_SERVICIO={item.fi_SERVICIO}
                fc_FAMILIA={item.fc_FAMILIA}
				textoVelocidad={textoVelocidad}		
                dataChannelsBk={dataChannelsBk}
                dataCategoriasBk={dataCategoriasBk}				
            />
        </div>
    )) : null

	const titulo_general 		= localStorage.getItem("titulo_general") ? localStorage.getItem("titulo_general") : ""
	const descripcion_general	= localStorage.getItem("descripcion_general") ? localStorage.getItem("descripcion_general") : ""
	const titulo_Selects 		= localStorage.getItem("titulo_Selects") ? localStorage.getItem("titulo_Selects") : ""
	const legales 				= localStorage.getItem("legales") ? localStorage.getItem("legales") : ""
	return (
		<>
			<section className='centralVirtual'>
				<div className='container'>
					<div className="contCentralVirtualTitle">
						{
							titulo_general &&
							<h1 className="centralVirtualTitle">{titulo_general}</h1>
						}
						{
							descripcion_general &&
							<p>{descripcion_general}</p>
						}
					</div>
					
					<div className="contCentralVirtualSearch">
						{
							titulo_Selects &&
							<p>{titulo_Selects}</p>
						}
						<form className="formCentralVirtual">
							{
								filTipoCentral.length > 0 &&
								<fieldset>
									<label>{filTipoCentral[0].fc_descripcion}</label>
									<span className="select">
										<select value={idTypeCentral} onChange={(e) => { onChangeCentralValue(e) }}>
											<option value="" disabled>...</option>
											{optionsCentral}
										</select>
									</span>
								</fieldset>
							}
							{
								filTipoPlan.length > 0 && 
								<fieldset>
									<label>{filTipoPlan[0].fc_descripcion}</label>
									<span className="select">
										<select value={idTypePlan} onChange={(e) => { onChangeTypePlanValue(e) }}>
											<option value="" disabled>...</option>
											{optionsTypePlan}
										</select>
									</span>
								</fieldset>
							}
							{
								filVelocidad[0]?.lstOpcionFiltro.length > 0 && idTypeCentral === 86 &&
								<fieldset>
									<label>{filVelocidad[0].fc_descripcion}</label>
									<span className="select">
										<select value={idVelocidad} onChange={(e) => { onChangeVelocidad(e) }}>
											<option value="" disabled>...</option>
											{optionsVelocidad}
										</select>
									</span>
								</fieldset>
							}
							{
								filTipoCentral.length > 0 && filTipoPlan.length > 0 &&
								<fieldset className="formCentralVirtualActions">
									{
										!spanSending
											? <button className="btn btnPrimario" type="button" onClick={()=>submitData()}>Buscar</button>
											: <span className='btn btnPrimario'>Enviando...</span>
									}
								</fieldset>
							}
						</form>
					</div>
					{
						showPlanes ?					
						<Slider {...settingsSliderPlanes} className="centralVirtualSlider">
							{PlayPLanData}
						</Slider>
						: null 
					}

					<div className='contInfCentralVirtual'>
						{Parser(String(legales))}
					</div>




				</div>
			</section>
			<Modal
                ref={modalTooltipRef}
                size={ModalSize.SMALL}
				>
				<>
				{
					localStorage.getItem("messageModalTooltip") ?
					<MTooltipModal
						message={localStorage.getItem("messageModalTooltip")}
					/> :
					<MTooltipModal/>
				}
				</>
                
            </Modal>
		</>
	);
}

export default CentralVirtual
